import { Route } from 'react-router-dom';
import { BookList } from './list';

export const BookRoute = (
  <Route path="books">
    <Route index element={<BookList />} />
  </Route>
);
